import React, { Component } from "react";
import api from "../../../utils/api";
import { BookmarkPageMedia } from "./bookmarkPageMedia";
import Header from "../../ui/header/header";
import {
	Title,
	Paragraph,
	SmallParagraph
} from "../../ui/typography/typography";
import { PrimaryLinkButton, SecondaryButton } from "../../ui/button/button";
import FlyoutContainer from "../../ui/flyout/flyoutContainer";
import { MoreIcon } from "../../ui/icons/icons";
import { TagList } from "../../ui/tags/tags";
import { List, ListItemLink, ListItemButton } from "../../ui/list/list";
import "../../ui/base/base.css";
import styles from "./bookmarkPage.css";

import { formatDate } from "../../../utils/numbersAndStrings";

class BookmarkPage extends Component {
	constructor() {
		super();

		this.state = {};

		this.onDelete = this.onDelete.bind(this);
	}

	async getData(uuid) {
		const bookmark = await api.bookmark.single(uuid);

		this.setState({ ...bookmark });
	}

	async onDelete() {
		const deleteConfirmed = window.confirm(
			"Are you sure you want to delete this bookmark?"
		);

		if (!deleteConfirmed) return;

		await api.bookmark.delete(this.state._id);
		this.props.history.push(`/`);
	}

	componentDidMount() {
		const uuid = this.props.match.params.uuid;

		this.getData(uuid);
	}

	render() {
		const {
			title,
			image,
			description,
			url,
			_id,
			tags,
			bookmarkedAt
		} = this.state;

		const time = new Date(bookmarkedAt);

		return (
			<div>
				<Header history={this.props.history} />
				<Title className={styles.title}>{title}</Title>

				<div className={styles.container}>
					<div className={styles.mediaContainer}>
						<BookmarkPageMedia url={url} image={image} />
					</div>

					<div className={styles.infoContainer}>
						<div className={styles.buttonGroup}>
							<PrimaryLinkButton href={url}>Visit bookmark</PrimaryLinkButton>
							<FlyoutContainer>
								<SecondaryButton>
									<MoreIcon />
								</SecondaryButton>
								<List>
									<ListItemLink href={`/bookmark/update/${_id}`}>
										Edit bookmark
									</ListItemLink>
									<ListItemButton onClick={this.onDelete}>
										Delete bookmark
									</ListItemButton>
								</List>
							</FlyoutContainer>
						</div>

						{description ? <Paragraph>{description}</Paragraph> : null}

						<SmallParagraph className={styles.meta}>
							{url} · {formatDate(time)}
						</SmallParagraph>

						{tags ? <TagList tags={tags} /> : null}
					</div>
				</div>
			</div>
		);
	}
}

export default BookmarkPage;



// WEBPACK FOOTER //
// ./src/components/pages/bookmarkPage/bookmarkPage.js